import { getTasks, saveTasks } from '../storage.js';
import { CATEGORIES } from '../tasks.js';

let _container = null;

function dragDotRows() {
  return [0,1,2].map(() =>
    `<div class="drag-handle-row">
      <div class="drag-dot"></div><div class="drag-dot"></div>
    </div>`
  ).join('');
}

function buildRow(task, idx, total) {
  const cat = CATEGORIES[task.category];
  return `
    <div class="settings-task-row" data-idx="${idx}" draggable="true">
      <div class="drag-handle">${dragDotRows()}</div>
      <div class="cat-dot" style="background:${cat.hex}"></div>
      <span class="settings-task-label" data-idx="${idx}">${task.label}</span>
      <div class="settings-task-actions">
        <button class="icon-btn edit-btn" data-idx="${idx}" title="Редагувати">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M11.5 2.5l2 2-8 8H3.5v-2l8-8z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>
            <path d="M10 4l2 2" stroke="currentColor" stroke-width="1.3"/>
          </svg>
        </button>
        <button class="icon-btn delete-btn" data-idx="${idx}" title="Видалити">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 5h10M6 5V3.5h4V5M6.5 8v4M9.5 8v4M4 5l.8 8h6.4l.8-8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>`;
}

function buildCatChips() {
  return Object.entries(CATEGORIES).map(([key, cat]) => `
    <div class="cat-chip" style="background:${cat.hex}30;border:1px solid ${cat.hex}80">
      <div class="cat-chip-dot" style="background:${cat.hex}"></div>
      <span class="cat-chip-label">${cat.label}</span>
    </div>`).join('');
}

function buildView(tasks) {
  return `
    <div class="view">
      <div class="view-header">
        <p class="view-eyebrow">Керування</p>
        <h1 class="view-title">Мої ритуали</h1>
      </div>

      <div class="card" style="padding:16px 18px;margin-bottom:16px">
        <p class="view-eyebrow" style="margin-bottom:12px">Категорії</p>
        <div class="cat-chips">${buildCatChips()}</div>
      </div>

      <div class="settings-task-list">
        ${tasks.map((t, i) => buildRow(t, i, tasks.length)).join('')}
      </div>

      <button class="add-ritual-btn">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Додати ритуал
      </button>
    </div>`;
}

function rerender() {
  if (!_container) return;
  const tasks = getTasks();
  _container.innerHTML = buildView(tasks);
  attachEvents(tasks);
}

function openAddModal() {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal-sheet">
      <p class="modal-title">Новий ритуал</p>
      <div class="modal-field">
        <label class="modal-label">Назва</label>
        <input class="modal-input" id="modal-label" placeholder="Наприклад, Контрастний душ" maxlength="60" autocomplete="off">
      </div>
      <div class="modal-field">
        <label class="modal-label">Категорія</label>
        <select class="modal-select" id="modal-cat">
          ${Object.entries(CATEGORIES).map(([k, c]) =>
            `<option value="${k}">${c.label}</option>`).join('')}
        </select>
      </div>
      <div class="modal-field">
        <label class="modal-label" style="display:flex;align-items:center;gap:8px;cursor:pointer">
          <input type="checkbox" id="modal-anti" style="accent-color:var(--accent)">
          Анти-звичка (не робити)
        </label>
      </div>
      <div class="modal-actions">
        <button class="btn-cancel" id="modal-cancel">Скасувати</button>
        <button class="btn-save" id="modal-save">Зберегти</button>
      </div>
    </div>`;

  document.body.appendChild(overlay);
  overlay.querySelector('#modal-label').focus();

  overlay.querySelector('#modal-cancel').addEventListener('click', () => overlay.remove());
  overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });

  overlay.querySelector('#modal-save').addEventListener('click', () => {
    const label = overlay.querySelector('#modal-label').value.trim();
    if (!label) { overlay.querySelector('#modal-label').focus(); return; }
    const category = overlay.querySelector('#modal-cat').value;
    const isAnti   = overlay.querySelector('#modal-anti').checked;
    const tasks    = getTasks();
    const newId    = category + '-' + Date.now();
    tasks.push({ id: newId, label, category, isAnti });
    saveTasks(tasks);
    overlay.remove();
    rerender();
  });
}

function startEdit(tasks, idx, labelEl) {
  labelEl.contentEditable = 'true';
  labelEl.focus();
  // Place cursor at end
  const range = document.createRange();
  range.selectNodeContents(labelEl);
  range.collapse(false);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);

  const save = () => {
    const newLabel = labelEl.textContent.trim();
    if (newLabel && newLabel !== tasks[idx].label) {
      tasks[idx] = { ...tasks[idx], label: newLabel };
      saveTasks(tasks);
    }
    labelEl.contentEditable = 'false';
  };

  labelEl.addEventListener('blur', save, { once: true });
  labelEl.addEventListener('keydown', e => {
    if (e.key === 'Enter') { e.preventDefault(); labelEl.blur(); }
    if (e.key === 'Escape') { labelEl.textContent = tasks[idx].label; labelEl.blur(); }
  }, { once: true });
}

function attachEvents(tasks) {
  if (!_container) return;

  // Edit buttons
  _container.querySelectorAll('.edit-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const idx     = +btn.dataset.idx;
      const row     = _container.querySelector(`.settings-task-row[data-idx="${idx}"]`);
      const labelEl = row.querySelector('.settings-task-label');
      startEdit(tasks, idx, labelEl);
    });
  });

  // Delete buttons
  _container.querySelectorAll('.delete-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const idx = +btn.dataset.idx;
      if (tasks.length <= 1) return;
      tasks.splice(idx, 1);
      saveTasks(tasks);
      rerender();
    });
  });

  // Add ritual
  _container.querySelector('.add-ritual-btn')?.addEventListener('click', openAddModal);

  // Drag-to-reorder
  let dragIdx = null;
  _container.querySelectorAll('.settings-task-row').forEach(row => {
    row.addEventListener('dragstart', e => {
      dragIdx = +row.dataset.idx;
      row.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
    });
    row.addEventListener('dragend', () => { row.style.opacity = ''; });
    row.addEventListener('dragover', e => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; });
    row.addEventListener('drop', e => {
      e.preventDefault();
      const dropIdx = +row.dataset.idx;
      if (dragIdx === null || dragIdx === dropIdx) return;
      const moved = tasks.splice(dragIdx, 1)[0];
      tasks.splice(dropIdx, 0, moved);
      saveTasks(tasks);
      rerender();
    });
  });
}

export function render(container) {
  _container = container;
  rerender();
}
